/**
 * Icon props base.
 *
 * @type {React.SVGProps<SVGSVGElement>}
 */
export const iconPropsBase = {
  'aria-hidden': true,
  'focusable': false,
  'fill': 'currentColor',
  'stroke': 'currentColor',
  'strokeWidth': 1.5,
  'style': {
    display: 'inline-block',
    userSelect: 'none',
    verticalAlign: 'middle',
    overflow: 'visible',
  },
};
